import store from './../../../store';
import accountService from './../../../services/account';
import bookingService from './../../../services/booking';
import Switches from 'vue-switches';
import adminService from './../../../services/admin';
import Vue from 'vue';
import configurationService from './../../../services/configuration';
import mixin from '../../../mixins/mixin';
import ColorPicker from './../../../components/colorpicker/Colorpicker';
import moment from 'moment';

export default {
  data() {
    return {
      users: [],
      contracts: [],
      invoices: [],
      error: null,
      success: false,
      loading: false,
      activeTab: 'users',
      user: {},
      usersPages: 0,
      usersPage: 1,
      userSearch: '',
      userSearchThrottle: null,
      disableSubscriptionBtn: false,
      videoSrc: '',
      topBarInfoText: '',
      topBarInfoEnabled: false,
      topBarInfoColor: '',
      importOrUpdateAirbnbBookingConfirmationCode: null,
      importOrUpdateAirbnbBookingRentalId: null,
    };
  },

  mixins: [mixin],

  components: {
    Switches,
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading: require('components/loading/loading.vue'),
    VChangeSubscriptionTrial: require('./ChangeSubscriptionTrial'),
    ColorPicker,
  },

  methods: {
    fetch_users() {
      adminService.getUsers(this);
    },

    fetch_invoices() {
      const vm = this;
      // TODO Create Service for fetch invoices
      Vue.$http.get('/templates/get-all/invoice').then((response) => {
        if (response.status === 200) {
          vm.invoices = response.data.templates;
          vm.loading = false;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },

    fetch_contracts() {
      const vm = this;
        // TODO Create Service for fetch contacts
      Vue.$http.get('/templates/get-all/contract')
            .then((response) => {
              if (response.status === 200) {
                vm.contracts = response.data.templates;
                vm.loading = false;
              }
            })
      .catch((error) => {
        console.log(error);
      });
    },

    async fetch_configuration() {
      const vm = this;
      const response = await configurationService.get(vm);
      vm.videoSrc = response.conf.onboarding_video;
      vm.topBarInfoText = response.conf.top_bar_info_text;
      vm.topBarInfoEnabled = response.conf.top_bar_info_enabled;
      vm.topBarInfoColor = response.conf.top_bar_info_color;
    },

    async change_status_user(user) {
      const isUserActive = !user.active;
      this.disableSubscriptionBtn = true;
      await adminService.changeStatus(this, user, {
        active: isUserActive,
      });
      await this.pause_subscription_user(user, !isUserActive);
    },

    pause_subscription_user(user, subscriptionStatus = null) {
      const data = {};
      data.pause_subscription = subscriptionStatus == null ? !user.pause_subscription : subscriptionStatus;
      adminService.pauseSubscription(this, user, data);
    },

    importOrUpdateAirbnbBooking() {
      if(!this.importOrUpdateAirbnbBookingConfirmationCode || typeof(this.importOrUpdateAirbnbBookingConfirmationCode) != 'string') {
        alert('Missing confirmation code');
        return;
      }
      console.log(typeof(this.importOrUpdateAirbnbBookingRentalId));
      if(!this.importOrUpdateAirbnbBookingRentalId || typeof(this.importOrUpdateAirbnbBookingRentalId) != 'number') {
        alert('Missing rental id');
        return;
      }
      const formButton = document.querySelector("#importOrUpdateAirbnbBooking button");
      formButton.disabled = true;
      formButton.innerHTML = 'Loading...';
      adminService.importOrUpdateAirbnbReservation(this, formButton);
    },

    change_tab(tab) {
      const vm = this;
      vm.activeTab = tab;
      if (vm.activeTab) {
        Vue.router.push({
          name: 'admin.index.tab',
          params: { tab: vm.activeTab },
        });
      }
    },

    search_user() {
      if(this.userSearchThrottle) {
        clearTimeout(this.userSearchThrottle)
        this.userSearchThrottle = null;
      }
      this.userSearchThrottle = setTimeout(() => {
        this.usersPage = 0;
        adminService.searchUser(this);
      }, 200);
    },

    search_user_next() {
      this.usersPage++;
      adminService.searchUser(this);
    },

    search_user_prev() {
      this.usersPage--;
      adminService.searchUser(this);
    },

    delete_user(id) {
      const vm = this;

      swal({
        title: 'Are you sure?',
        text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>Would you like to delete this user ?</div>',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Not now',
        confirmButtonClass: 'btn-success',
        confirmButtonText: 'Yes, do it!',
        closeOnConfirm: false,
        html: true,
      },
        (isConfirm) => {
          if (isConfirm) {
            $('.pulseWarning').hide();
            $('.cancel').addClass('disabled');
            $('.confirm').addClass('disabled');
            $('#loading1').show();
            // TODO Create Service for delete sub users
            Vue.$http.delete(`/sub-users/${id}`).then((response) => {
              if (response.status === 200) {
                $('.cancel').removeClass('disabled');
                $('.confirm').removeClass('disabled');
                const message = 'User deleted successfully';
                swal('Done!', message, 'success');
                vm.fetch_users();
              }
            }).catch((error) => {
              $('.cancel').removeClass('disabled');
              $('.confirm').removeClass('disabled');
              swal('Error!', error.response.data.msg, 'warning');
            });
          }
        });
    },

    openUpdateAirbnbBookingModal(id) {
      $("#update-airbnb-booking-" + id).modal('show');
    },
    updateAirbnbBooking(data, id) {
      bookingService.updateAirbnbBooking(this, data, id);
    },

    edit(contract, type) {
      const vm = this;

      Vue.router.push({
        name: 'admin.template.edit',
        params: { id: contract.id, type },
      });
    },

    new_user() {
      alert('new_user');
    },

    new_template(type) {
      Vue.router.push({
        name: 'admin.template.create',
        params: { type },
      });
    },

    delete_tempalte(id, type) {
      const vm = this;

      swal({
        title: 'Are you sure?',
        text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>Would you like to delete this user ?</div>',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Not now',
        confirmButtonClass: 'btn-success',
        confirmButtonText: 'Yes, do it!',
        closeOnConfirm: false,
        html: true,
      },
          (isConfirm) => {
            if (isConfirm) {
              $('.pulseWarning').hide();
              $('.cancel').addClass('disabled');
              $('.confirm').addClass('disabled');
              $('#loading1').show();
              // TODO Create Service for delete templates
              Vue.$http.delete(`/templates/${id}`).then((response) => {
                if (response.status === 200) {
                  $('.cancel').removeClass('disabled');
                  $('.confirm').removeClass('disabled');
                  const message = 'Contract deleted successfully';
                  swal('Done!', message, 'success');
                  switch (type) {
                    case 'contract':
                      vm.fetch_contracts();
                      break;
                    case 'invoice':
                      vm.fetch_invoices();
                      break;
                  }
                }
              }).catch((error) => {
                $('.cancel').removeClass('disabled');
                $('.confirm').removeClass('disabled');
                swal('Error!', error.response.data.msg, 'warning');
              });
            }
          });
    },

    updateVideo() {
      const vm = this;
      const data = {
        videoSrc: '',
      };
      data.videoSrc = vm.videoSrc;
      configurationService.updateVideo(vm, data);
    },

    updateTopBarInfo() {
      const vm = this;
      const data = {
        top_bar_info_text: vm.topBarInfoText,
        top_bar_info_enabled: vm.topBarInfoEnabled,
        top_bar_info_color: vm.topBarInfoColor,
      };
      configurationService.updateTopBarInfo(vm, data);
    },

    confirm_user(user) {
      const vm = this;
      accountService.confirmUser(vm, user);
    },

    openChangeTrialModal(user) {
      this.user = {
        ...user,
      };
      this.openModal('#change-user-trial');
    },

    getTrialDate(date) {
      return moment(date).format('DD MMM YYYY');
    },

    getStartDate(date) {
      return moment(date).format('DD MMM YYYY');
    },

    changePlan(userId, planId = 4) {
      const data = {
        userId,
        planId,
      };
      this.loading = true;
      adminService.changeUserPlan(this, data);
    },
  },

  async mounted() {
    const vm = this;
    if (vm.$route.params.tab) {
      vm.change_tab(vm.$route.params.tab);
    }
    vm.loading = true;
    vm.search_user();
    // vm.fetch_invoices();
    vm.fetch_contracts();
    vm.fetch_configuration();
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/admin/index/index.js